<div
  class="navbar absolute z-[1000] h-screen w-screen flex flex-col justify-center items-center bg-base-100 dark:bg-primary"
>
  <button
    class="flex btn bg-transparent hover:bg-transparent w-100 h-fit border-0 w-48 shadow-none dark:hidden"
  >
    <img class="w-full" src="/assets/logo/qwikopay-hz-logo-dark.svg" alt="" />
  </button>
  <button
    class="btn bg-transparent hover:bg-transparent w-100 h-fit border-0 w-48 shadow-none hidden dark:!flex"
  >
    <img class="w-full" src="/assets/logo/qwikopay-hz-logo-light.svg" alt="" />
  </button>
  <qwiko-alert [margin]="true"></qwiko-alert>
  <span
    class="loading size-10 dark:text-white text-primary loading-spinner mt-4"
  ></span>
</div>
